var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcInProgress = function SvgIcInProgress(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M5.031 13.837a7.213 7.213 0 0 0 5.626 5.239.8.8 0 0 1-.295 1.572 8.808 8.808 0 0 1-6.878-6.404.8.8 0 1 1 1.547-.407zm8.531-10.491.108.013a8.803 8.803 0 0 1 .02 17.278.8.8 0 0 1-.306-1.571 7.202 7.202 0 0 0-.017-14.136.8.8 0 0 1 .089-1.583l.106-.001zM5.773 6.908a.8.8 0 0 1 .223 1.109 7.135 7.135 0 0 0-1.151 3.133.8.8 0 0 1-1.589-.187A8.756 8.756 0 0 1 4.664 7.13a.801.801 0 0 1 1.11-.222zm5.508-2.917a.799.799 0 0 1-.637.935c-1 .19-1.94.59-2.77 1.169a.8.8 0 1 1-.916-1.312 8.761 8.761 0 0 1 3.388-1.429.8.8 0 0 1 .935.637z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BDBDBD",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcInProgress);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-in-progress.16cedf5b07c577543dd4f51516158614.svg";